import { Team, User, UserReferrer } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';
import { ComponentHelpers } from 'helpers/ComponentHelpers';
import { DesignLibraryHelpers } from 'helpers/DesignLibraryHelpers';
import { EventHelpers } from 'helpers/EventHelpers';
import { ProjectHelpers } from 'helpers/ProjectHelpers';

export type SearchTab = 'products' | 'designs' | 'profiles' | 'caseStudies' | 'dc-microgrids';

const RouterHelpers = {
    urls: {
        profiles: CompanyHelpers.urls,
        products: ComponentHelpers.urls,
        designs: DesignLibraryHelpers.urls,
        projects: ProjectHelpers.urls,
        events: EventHelpers.urls,

        homepage: (team?: Team | null, user?: User | null, referrer?: UserReferrer) => {
            return '/';
        },

        searchAssistant: () => '/events/plan',

        map: () => '/map',

        caseStudies: () => '/case-studies',
    },
};

export { RouterHelpers };
